import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, FormGroup, Input, InputGroup } from 'reactstrap';
import { axios } from '../../../../services/ServiceUtils';
import HomeContext from '../../../../contexts/HomeContext';
import LanguageContext from '../../../../contexts/LanguageContext';
import {
  Box,
  Icon,
  Label,
  Title,
  AllFAQLink,
  LinkRow,
  BottomLink,
  ButtonFaq,
  ButtonBox,
  Disclaimer,
} from './styles';

const HelpBlock = () => {
  const {
    needHelp: {
      title,
      accountTypeHeading,
      categoryHeading,
      viewAllFaq,
      findAnswers,
      contactUs,
      productSupport,
    },
  } = useContext(HomeContext);

  const [dataHelpBlock, setDataHelpBlock] = useState({
    title: '',
    accountTypeLabel: '',
    categoryLabel: '',
    faqLink: {
      url: '',
      text: '',
      target: '',
    },
    bottomLinks: [],
    dfsAccountTypes: [
      {
        accountType: '',
        categories: [],
        id: '',
      },
    ],
  });
  const { language } = useContext(LanguageContext);
  const [accountType, setAccountType] = useState({});
  const [questionCategory, setQuestionCategory] = useState('');
  const [questionCategories, setQuestionCategories] = useState([]);
  const handleAccountType = e => {
    if (e.target.value !== '') {
      //eslint-disable-next-line
      dataHelpBlock.dfsAccountTypes.map(select => {
        if (select.accountType === e.target.value) {
          setAccountType(select);
          setQuestionCategories(select.categories);
          setQuestionCategory();
          //eslint-disable-next-line
          select.categories.map(category => {
            if (category.key === questionCategory) {
              setQuestionCategory(category.key);
            }
          });
        }
      });
    } else {
      setAccountType({
        accountType: '',
        categories: [],
        id: '',
      });
      setQuestionCategories([]);
      setQuestionCategory();
    }
  };
  const handleQuestionCategory = e => setQuestionCategory(e.target.value);

  useEffect(() => {
    axios
      .get('api/need-help', {
        headers: {
          'Content-Language': `${language.locale}`,
        },
      })
      .then(result => {
        setDataHelpBlock(result.data);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.error('request error', e);
      });
  }, [language]);

  return dataHelpBlock.dfsAccountTypes && dataHelpBlock.dfsAccountTypes.length > 0 ? (
    <>
      <Box className="row mx-0 px-lg-4 px-0 py-0 mt-n3 mb-3 pt-lg-3 mt-lg-3">
        <Title className="py-1 px-0 mb-0 mb-lg-2">{title}</Title>
        <Container>
          <Row>
            <Col xs="12" md="4" xl="5" className="px-0 mx-0">
              <FormGroup>
                <Label htmlFor="accountType" className="mb-0">
                  {accountTypeHeading}
                </Label>
                <Input
                  type="select"
                  id="accountType"
                  value={accountType.accountType}
                  onChange={handleAccountType}
                >
                  <option value="">Select account type</option>
                  {dataHelpBlock.dfsAccountTypes
                    .sort((a, b) => {
                      if (a.accountType < b.accountType) return -1;
                      if (a.accountType > b.accountType) return 1;
                      return 0;
                    })
                    .map(accType => (
                      <option value={accType.accountType} key={accType.id}>
                        {accType.accountType.substr(accType.accountType.indexOf('-') + 1)}
                      </option>
                    ))}
                </Input>
              </FormGroup>
            </Col>
            <Col xs="12" md="8" xl="7" className="px-0 mx-0 pl-md-3">
              <Label htmlFor="questionCategory" className="mb-0">
                {categoryHeading}
              </Label>
              <InputGroup>
                <Input
                  type="select"
                  id="questionCategory"
                  name="questionCategory"
                  onChange={handleQuestionCategory}
                >
                  <option value="">Select category</option>
                  {questionCategories
                    .sort((a, b) => {
                      if (a.name < b.name) return -1;
                      if (a.name > b.name) return 1;
                      return 0;
                    })
                    .map(category => (
                      <option value={category.key} key={category.key}>
                        {category.name.substr(category.name.indexOf('-') + 1)}
                      </option>
                    ))}
                </Input>
                <ButtonBox className="input-group-append ml-md-3 py-3 py-md-0 pt-md-n3">
                  <ButtonFaq
                    className="btn-sm py-2 mt-0 flex-lg-fill"
                    color="primary"
                    to={`/faq/${accountType.id ?? ''}${
                      questionCategory ? '/' + questionCategory : ''
                    }`}
                    tag={Link}
                  >
                    {findAnswers.title}
                  </ButtonFaq>
                </ButtonBox>
              </InputGroup>
            </Col>
          </Row>
          {viewAllFaq.title ? (
            <Row>
              <Col xs="12" className="px-0 pt-3 pt-sm-0 p-sm-0">
                <AllFAQLink href={viewAllFaq.url} target={viewAllFaq.target}>
                  <u>{viewAllFaq.title}</u>
                </AllFAQLink>
                {language.locale.toUpperCase() === 'EN-US' && (
                  <Disclaimer>
                    DFS does not provide any language access services per the New York City
                    Department of Consumer Affairs Rules. However, a translation and description of
                    commonly-used debt collection terms is available in multiple languages on the
                    Department’s website{' '}
                    <a
                      href="https://www1.nyc.gov/site/dca/consumers/Glossary-of-Common-Debt-Collection-Terms.page"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <u>Glossary Links</u>
                    </a>
                    .
                  </Disclaimer>
                )}
              </Col>
            </Row>
          ) : null}
          <LinkRow className="row my-4 pt-2 pb-0">
            <Col xs="6" className="pl-3 pr-0 mt-2 pl-lg-0">
              {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
              <Icon className="dds__icons mr-2" role="img" aria-label={`${contactUs.title} icon`}>
                💁
              </Icon>
              <BottomLink href={contactUs.url} target={contactUs.newWindow ? '_blank' : '_self'}>
                <u>{contactUs.title}</u>
              </BottomLink>
            </Col>
            <Col xs="6" className="pl-3 pr-0 mt-2 pl-lg-0">
              {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
              <Icon
                className="dds__icons mr-2"
                role="img"
                aria-label={`${productSupport.title} icon`}
              >
                🛠
              </Icon>
              <BottomLink
                href={productSupport.url}
                target={productSupport.newWindow ? '_blank' : '_self'}
              >
                <u>{productSupport.title}</u>
              </BottomLink>
            </Col>
          </LinkRow>
        </Container>
      </Box>
    </>
  ) : null;
};

export default HelpBlock;
